import type { InfiniteData, InfiniteQueryObserverResult } from '@tanstack/svelte-query';

/**
 * Whether an infinite query should fetch another page to catch back up to a
 * previously persisted item count (e.g. one stored in history-entry state so
 * back/forward navigation restores "Show more" clicks after the query cache
 * has been garbage-collected).
 *
 * Callers re-evaluate this from a reactive effect as pages arrive; the
 * in-flight and error guards are what stop that effect from looping.
 */
export function shouldRestoreInfiniteItems<T>({
	query,
	targetCount,
	loadedCount
}: {
	query: InfiniteQueryObserverResult<InfiniteData<T, unknown>, Error>;
	targetCount: number | undefined;
	loadedCount: number;
}) {
	if (!targetCount || loadedCount >= targetCount) {
		return false;
	}

	return query.hasNextPage && !query.isFetching && !query.isError;
}
